import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  pillsContainer: css`
    display: flex;
    min-width: 0;
    flex-wrap: wrap;

    gap: 8px;
    align-items: center;

    @media (max-width: 360px) {
      gap: 6px;
    }
  `,
  input: css`
    & > div {
      flex-wrap: wrap;

      input {
        flex: 1 0 120px;
      }
    }
  `,
} satisfies Styles<void>;

export const useInputRequirementStyles = withStyles(styles);
